export default __webpack_public_path__ + "static/Is VR training only for a niche market and are VR headsets costly-0aa16c4e882727829753f159512ac2f8.jpg";